import axios from 'axios';

export async function fetchDocs() {
  const response = await axios.get('api/docgen/wix/react-native-ui-lib/src/');
  return response.data;
}



// WEBPACK FOOTER //
// ./services/DocsService.js